export enum ParticipantType {
  Guardian = "Guardian",
  CoveredPerson = "CoveredPerson",
}
